import { __decorate } from "tslib";
import { module } from 'angular';
import { NgModule } from 'angular-ts-decorators';
import { SharedModule } from 'src/shared';
import { ApplicableProductComponent } from './applicable-product/applicable-product.component';
import { ApplicableProductsComponent } from './applicable-products/applicable-products.component';
import { FaqBottomMessageComponent } from './faq-bottom-message/faq-bottom-message.component';
import { FaqCategorySelectComponent } from './faq-category-select/faq-category-select.component';
import { FaqItemsComponent } from './faq-items/faq-items.component';
import { FaqSearchControlsComponent } from './faq-search-controls/faq-search-controls.component';
import { FaqTeasersSpotComponent } from './faq-teasers-spot/faq-teasers-spot.component';
import { FaqTeasersComponent } from './faq-teasers/faq-teasers.component';
import { FaqViewButtonsComponent } from './faq-view-buttons/faq-view-buttons.component';
import { LiveTypingDirective } from './directives/live-typing.directive';
import { FaqTeasersService } from './faq-teasers/faq-teasers.service';
import { AllFaqsSpotController } from './all-faqs-spot/all-faqs-spot-controller';
import { FaqSpotV2Controller } from './faq-spot-v2/faq-spot-v2.controller';
import { RelatedFaqsSpotController } from './related-faqs-spot/related-faqs-spot.controller';
import { SetupAndPairingFaqSpotController } from './setup-and-pairing-faq-spot/setup-and-pairing-faq-spot.controller';
import { SingleFaqSpotController } from './single-faq-spot/single-faq-spot.controller';
import { SupportDesignModule } from 'src/Foundation/Design/app';
var moduleId = 'gn.audio.support.faq';
var legacyModuleId = moduleId + ".legacy";
module(legacyModuleId, [])
    .controller('AllFaqsSpotController', AllFaqsSpotController)
    .controller('FaqSpotV2Controller', FaqSpotV2Controller)
    .controller('RelatedFaqsSpotController', RelatedFaqsSpotController)
    .controller('SetupAndPairingFaqSpotController', SetupAndPairingFaqSpotController)
    .controller('SingleFaqSpotController', SingleFaqSpotController);
var FaqModule = (function () {
    function FaqModule() {
    }
    FaqModule = __decorate([
        NgModule({
            declarations: [
                ApplicableProductComponent,
                ApplicableProductsComponent,
                FaqBottomMessageComponent,
                FaqCategorySelectComponent,
                FaqItemsComponent,
                FaqSearchControlsComponent,
                FaqViewButtonsComponent,
                FaqTeasersComponent,
                FaqTeasersSpotComponent,
                LiveTypingDirective,
            ],
            id: moduleId,
            imports: [legacyModuleId, SupportDesignModule, SharedModule],
            providers: [FaqTeasersService],
        })
    ], FaqModule);
    return FaqModule;
}());
export { FaqModule };
